module.exports = __webpack_public_path__ + "img/logo_sinotruk.8df20808.png";